import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Sentry, initSentry } from "./sentry";
import "./styles/index.scss";
import "sfy-react/build/css/index.css";
import "react-datetime/css/react-datetime.css";
import "rsuite/dist/rsuite-no-reset.min.css";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { persistor, store } from "./reduxToolkit/store";

const rootElement = document.getElementById("root");
document.getElementById("loader").style.display = "none";

initSentry(rootElement.dataset.sentryDsn, rootElement.dataset.env);

const root = createRoot(rootElement); // Create root
root.render( // Call render on the root
	<Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<App {...rootElement.dataset} />
			</PersistGate>
		</Provider>
	</Sentry.ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();